export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_ENTRA_TENANT_ID}`,
    redirectUri: process.env.VUE_APP_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
}

export const loginRequest = {
  scopes: ['openid', 'profile'],
}
